import React from 'react'
import { Image, OverlayTrigger } from 'react-bootstrap'
import { getTotal, getSizeNumbers, getSizeEntries } from '../presentational-components/TableComponent'
import { RenderImage } from '../presentational-components/ImageViewer'

const DeliveryOrder = ({ sizeCat, articleTypes, removeOrderEntry, isDeliveryOrder, setHasInvalidArticles }) => {
    console.log("Category: " + sizeCat, "ArticleEntries: " + articleTypes[0].articleName, "SizeEntries: ")
    console.log(articleTypes)
    console.log(sizeCat, articleTypes, removeOrderEntry, isDeliveryOrder, setHasInvalidArticles)

    const invalidAmount = (deliveryOrder) => {
        console.log("Check invalid amounts")
        console.log(deliveryOrder)
        console.log("Check invalid amounts2")


        //deliveryOrder.sizeEntries.foreach(x => articles.find(article => article.articleTypeSysId === x.articleTypeSysId).sizeEntries x.SizeValue )
        let invalidAmounts = deliveryOrder.sizeEntries.filter(x => x.Amount > x.AmountInStorage)

        console.log("Check invalid amounts3")

        if (invalidAmounts.length > 0) {
            setHasInvalidArticles(true)
            return true
        } else {
            setHasInvalidArticles(false)
            return false
        }
    }

    const getInvalidAmount = (deliveryOrder) => {
        let invalidAmounts = deliveryOrder.sizeEntries.filter(x => x.Amount > x.AmountInStorage).map(x => ({ SizeValue: x.SizeValue, WrongAmount: x.Amount - x.AmountInStorage } ))

        return invalidAmounts.map(x => <div>Größe {x.SizeValue} ist um {x.WrongAmount} zu hoch.</div>)
    }

    const getTotalTotal = (articleTypes) => {
        let numbersTotal = 0
        articleTypes.forEach(x => {
            let numbers = x.sizeEntries.map(entry => parseInt(entry.Amount))
            let total = 0
            numbers.map(number => total = parseInt(total) + parseInt(number))

            numbersTotal += total
        })

        return numbersTotal
    }

    return (
        <>
            <thead className="sticky-table-header">
                <tr>
                    <th>Ansicht</th>
                    <th>Designername</th>
                    <th>Artikelnr. (FAEX)</th>
                    <th>Artikelnr. (Designer)</th>
                    <th>Vk-Preis</th>
                    <th>{sizeCat}</th>
                    {getSizeEntries(articleTypes[0].sizeEntries)}
                    <th className="numberColumn">Total</th>
                </tr>
            </thead>

            <tbody>
                {articleTypes.map(entry => 
                    <>
                        <tr className={isDeliveryOrder ? invalidAmount(entry) ? "error" : "" : ""}>
                            <td>{RenderImage(entry.image)}</td>
                            <td>{entry.designerName}</td>
                            <td>{entry.articleIdFaex}</td>
                            <td>{entry.articleNumberDesigner}</td>
                            <td className="numberColumn">{parseFloat(entry.salePrice).toFixed(2).replace('.', ',') + "€"}</td>
                            <td>{entry.articleName}</td>
                            {getSizeNumbers(entry.sizeEntries)}
                            {getTotal(entry.sizeEntries)}
                            <td className="remove-order-td"><a className="remove-order" href="" onClick={(event) => removeOrderEntry(event, sizeCat, entry)} variant="secondary">&#10060;</a></td>
                        </tr>
                        {invalidAmount(entry) && <tr className="error"><td colSpan="20">Die zu verschickenden Artikel für "{entry.articleName}" stimmen nicht mit dem Bestand überein. Folgende Angaben sind falsch: <br /> {getInvalidAmount(entry)} </td></tr>}
                    </>
                )}
                <tr>
                    <td></td><td></td><td></td><td></td><td></td><td></td>
                    <td className="stockReport-row">Summe: {getTotalTotal(articleTypes)}</td>
                </tr>
            </tbody>
            
        </>
    );
}

export default DeliveryOrder